import React from 'react'
import PropTypes from 'prop-types'
import { useMedia } from 'sb-hooks'
import { useConnect } from 'sb-redux-hook'

import InsideLayout from 'layouts/InsideLayout/InsideLayout'
import DiscountCountdownBanner from 'components/headerBanners/DiscountCountdownBanner/DiscountCountdownBanner'

import Header from './Header/Header'
import Footer from './Footer/Footer'

import s from './LandingLayout.scss'


const LandingLayout = (props) => {
  const {
    children, withBanner, withSearchInput, withDiscountBanner, withSubHeader, withBreadcrumbs, headerColor,
  } = props

  const { isLoggedIn } = useConnect({
    isLoggedIn: 'models.me.isLoggedIn',
  })

  const { isMobile } = useMedia()

  return isLoggedIn ? (
    <InsideLayout {...{ withBanner, withSearchInput, withSubHeader, withBreadcrumbs }}>
      {children}
    </InsideLayout>
  ) : (
    <div className={s.wrapper}>
      <div className={s.headerContainer}>
        {
          withDiscountBanner && (
            <DiscountCountdownBanner horizontal={!isMobile} uppercase={false} />
          )
        }
        <Header {...{ withSubHeader, withSearchInput, headerColor }} />
      </div>
      <div className={s.contentContainer}>
        {children}
      </div>
      <Footer minimal={isMobile} />
    </div>
  )
}

LandingLayout.propTypes = {
  withDiscountBanner: PropTypes.bool,
  withBreadcrumbs: PropTypes.bool,
  withSearchInput: PropTypes.bool,
  withSubHeader: PropTypes.bool,
  withBanner: PropTypes.bool,
  headerColor: PropTypes.string,
  children: PropTypes.node,
}

LandingLayout.defaultProps = {
  withSearchInput: true,
  withBanner: true,
}


export default LandingLayout
